const nameSpace = 'progressReport'

export const mutations = {
  SET_TABLE_DATA: `${nameSpace}/SET_TABLE_DATA`,
  SET_MIDDLE_LANG: `${nameSpace}/SET_MIDDLE_LANG`,
  SET_CHART_DATA: `${nameSpace}/SET_CHART_DATA`,
  SET_TODAY: `${nameSpace}/SET_TODAY`,
}

export const actions = {
  GET_INITIAL_TABLE_DATA: `${nameSpace}/GET_INITIAL_TABLE_DATA`,
  CHANGE_BP: `${nameSpace}/CHANGE_BP`,
  CHANGE_CHART: `${nameSpace}/CHANGE_CHART`,
  CHANGE_SELECTED_IO_ID: `${nameSpace}/CHANGE_SELECTED_IO_ID`,
}

export const getters = {
  tableData: `${nameSpace}/tableData`,
  chartData: `${nameSpace}/chartData`,
  BPList: `${nameSpace}/BPList`,
  IOProgressData: `${nameSpace}/IOProgressData`,
  middleLang: `${nameSpace}/middleLang`,
  selectedIOId: `${nameSpace}/selectedIOId`,
  today: `${nameSpace}/today`,
}
